import React, { useEffect, useState } from 'react';
import './VacationNotice.css';

// L'avviso si mostra da solo fino al 19 agosto 2026 incluso,
// dal 20 agosto sparisce automaticamente (nessun deploy necessario).
const LAST_DAY = new Date(2026, 7, 20); // 20 agosto 2026, 00:00 ora locale
const STORAGE_KEY = 'maithai_vacation_notice_closed';

const isNoticeActive = () => {
  if (new Date() >= LAST_DAY) return false;
  try {
    return sessionStorage.getItem(STORAGE_KEY) !== 'true';
  } catch (e) {
    return true;
  }
};

const VacationNotice = () => {
  const [visible, setVisible] = useState(isNoticeActive);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (!visible) return undefined;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [visible]);

  if (!visible) return null;

  const handleClose = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // sessionStorage non disponibile: l'avviso riapparirà al prossimo caricamento
    }
    setClosing(true);
    setTimeout(() => setVisible(false), 400);
  };

  return (
    <div className={`vacation-notice ${closing ? 'vacation-notice--closing' : ''}`} role="dialog" aria-modal="true" aria-label="Siamo in ferie - We're on vacation">
      <button type="button" className="vacation-notice__close" onClick={handleClose} aria-label="Chiudi avviso / Close notice">
        &#10005;
      </button>

      <div className="vacation-notice__content">
        <div className="vacation-notice__sun" aria-hidden="true" />

        <p className="vacation-notice__dates">12 &mdash; 19 AGOSTO &middot; AUGUST</p>

        <h1 className="vacation-notice__title">Siamo in ferie</h1>
        <p className="vacation-notice__subtitle">We&apos;re on vacation</p>

        <div className="vacation-notice__arc" aria-hidden="true">
          <span className="vacation-notice__dot vacation-notice__dot--left" />
          <span className="vacation-notice__dot vacation-notice__dot--right" />
        </div>

        <p className="vacation-notice__closed">Chiusi dal 12 al 19 agosto (compreso)</p>
        <p className="vacation-notice__closed-en">Closed August 12&ndash;19 (included)</p>

        <p className="vacation-notice__back">Riapriamo il 20 agosto &#9728;</p>
        <p className="vacation-notice__back-en">Back on August 20</p>

        <button type="button" className="vacation-notice__enter" onClick={handleClose}>
          Entra nel sito &middot; Enter the site
        </button>

        <p className="vacation-notice__greeting">BUONA ESTATE</p>
      </div>
    </div>
  );
};

export default VacationNotice;
